import { useFilterUtilActivityTypeContext } from "./filter-util-activity-type.context";

export function FilterUtilActivityType() {
  const { dateFilterElement, clearFiltersElement } =
    useFilterUtilActivityTypeContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {clearFiltersElement}
    </div>
  );
}